var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { TextBody } from '@ally/metronome-ui';
var StyledTextBody = styled(TextBody)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  word-break: break-word;\n"], ["\n  display: block;\n  word-break: break-word;\n"])));
export var Term = forwardRef(function (_a, ref) {
    var children = _a.children;
    return (React.createElement(StyledTextBody, { tag: "dt", size: "sm", weight: "bold", ref: ref, tabIndex: -1 }, children));
});
export var Details = function (_a) {
    var children = _a.children;
    return (React.createElement(StyledTextBody, { tag: "dd", size: "sm" }, children));
};
export var Description = function (_a) {
    var term = _a.term, details = _a.details;
    return (React.createElement(React.Fragment, null,
        React.createElement(Term, null, term),
        React.createElement(Details, null, details)));
};
var templateObject_1;
//# sourceMappingURL=Description.js.map